import { Button } from "@/components";
import { ReactNode } from "react";
import { FaTrash } from "react-icons/fa";
import { useDeleteUser } from "../hooks";
import { cn } from "@/utils";
import {Modal} from "@/components";

interface DeleteUserProps {
  triggerClassName?: string;
  children?: ReactNode;
  userId: number;
  onDeleteUser?: (id: number) => Promise<void>;
  disabled?: boolean;
}

export const DeleteUser = ({
  triggerClassName,
  userId,
  onDeleteUser,
  children,
  disabled,
}: DeleteUserProps) => {
  const { handleOpen, open, handleClose, handleDelete, isLoading } =
    useDeleteUser({
      userId,
      onDeleteUser,
    });

  return (
    <>
      {children ? (
        <div
          className={cn(triggerClassName, disabled ? "opacity-50" : "")}
          onClick={(e) => {
            if (disabled) return;
            handleOpen(e);
          }}
          role="button"
          tabIndex={0}
        >
          {children}
        </div>
      ) : (
        <button onClick={handleOpen} disabled={disabled}>
          <FaTrash className={cn("w-4 h-4 text-grey-600/80 hover:text-red-600", disabled ? "opacity-50" : "")} />
        </button>
      )}
      <Modal
        title={"アカウントを削除しますか？"}
        open={open}
        onOpenChange={handleClose}
      >
        <div>
          <p
            className="text-sm leading-[1.375rem] p-4"
            style={{ boxShadow: "0 -1px 0 0 rgba(0, 0, 0, 0.10) inset" }}
          >
            この操作は永久的で、元に戻すことはできません。 <br />
            関連するすべてのデータはシステムから完全に削除されます。
            <br />
            本当に続行してもよろしいですか？
          </p>
          <div className="flex justify-end gap-5 p-4">
            <Button
              buttonType="text"
              onClick={handleClose}
              className="!h-12 hover:bg-white !px-0 !rounded-lg !text-[15px] !font-bold"
            >
              キャンセル
            </Button>
            <Button
              variant="solid"
              color="danger"
              onClick={handleDelete}
              className="!h-12 px-[22px] py-[11px] !rounded-lg !text-[15px] !font-bold"
              disabled={isLoading}
            >
              削除
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
